<template>
  <b-sidebar
    id="sidebar-old-reject-apply-document"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t('Rejected') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />
      </div>
      <validation-observer ref="rejectApplyDocument">
        <!-- Body -->
        <b-form
          class="p-2"
          @submit.prevent
        >

          <b-form-group
            :label="$t('Rejected info')"
            label-for="rejected-info"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Rejected info')"
              rules="required"
            >
              <b-form-textarea
                id="rejected-info"
                v-model="rejected_info"
                trim
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ $t('Rejected') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormTextarea, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@/libs/validations/validations'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormTextarea,
    BButton,
    ValidationObserver,
    ValidationProvider,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      rejected_info: '',
      required,
    }
  },
  computed: {
    applyDocument() {
      return this.$store.state[this.MODULE_NAME].applyDocument
    },
  },
  mounted() {
    localize(this.$i18n.locale)
  },
  methods: {
    clear(hide) {
      this.rejected_info = ''
      hide()
    },
    submit(hide) {
      this.$refs.rejectApplyDocument.validate().then(success => {
        if (success) {
          this.$removeSwal(this, {
            id: this.applyDocument.id,
            rejected_info: this.rejected_info,
          }, `${this.MODULE_NAME}/oldReject`, () => {
            this.$emit('refetchData')
            this.rejected_info = ''
            hide()
          }, {
            text: '',
            confirmButtonText: 'Yes, reject it!',
            successTitle: 'Reject!',
            successText: 'Your file has been rejected.',
            errorText: 'Your file has not been rejected.',
          })
        }
        hide()
      })
    },
  },
  setup() {
    const MODULE_NAME = 'applyDocument'
    return {
      MODULE_NAME,
    }
  },
}
</script>
